<template>
  <div>
    <el-dialog title="确认入库" :visible.sync="xcVisible" :close-on-click-modal="false" width="80%" center :before-close="closeadd">
      <div class="topForm">
        <div class="top" style="display:inline-block;font-size:16px;margin-bottom:10px;margin-left:10px;">
          车号：<span>{{chepai}}</span>
        </div>
        <div v-if="isJiesuan" style="display:inline-block;font-size:16px;margin-bottom:10px;margin-left:20px;">
          <span class="jiesuanCustomer">结算客户：</span>
          <el-select size="small" filterable v-model="customer" placeholder="请选择" @change="customerChange">
            <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="bottomTable">
        <div class="detailsTitle">
          <h4>货物信息</h4>
        </div>
        <el-table min-height="300px" size="mini" border center bordersize="mini" ref="tableref" :data="table" style="width: 100%" class="elTab">
          <el-table-column prop="number" label="件数" align="center">
            <template slot-scope="scope1">
              <el-input v-model="scope1.row.number" maxlength="50" placeholder="请输入件数" size="mini" @change="NumberInput(scope1.row)" v-number-input.float="0"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="理重(吨)" align="center">
            <template slot-scope="scope1">
              <el-input v-model="scope1.row.weight" maxlength="50" placeholder="请输入理重(吨)" size="mini" :disabled="true"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="weighingWeight" label="过磅净重(吨)" align="center">
            <template slot-scope="scope1">
              <el-input v-model="scope1.row.weighingWeight" maxlength="50" placeholder="请输入过磅净重(吨)" size="mini" @change="weighingWeightChange(scope1.row)" v-number-input.float="4"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="warehouseId" label="仓位" align="center">
            <template slot-scope="scope1">
              <el-select ref="selectProvinces" @visible-change='isShowSelectOptions' filterable clearable v-model="scope1.row.warehouseId" size="mini" placeholder="请选择仓位" @change="selectCangwei(scope1.row)">
                <el-option v-for="(item,index) in warehouseOptions" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="outNumber" label="出厂车号" align="center">
            <template slot-scope="scope1">
              <el-input v-model="scope1.row.outNumber" maxlength="50" placeholder="请输入出厂车号" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重(吨)" align="center"></el-table-column>
        </el-table>
        <div v-if="isJiesuan" class="detailsTitle" style="margin-top:20px;">
          <h4>费用信息</h4>
          <div class="positionA">费用合计：<span>{{totalFee}}</span>元</div>
        </div>
        <el-table v-if="isJiesuan" min-height="300px" size="mini" border center bordersize="mini" ref="tableref" :data="feeTable" style="width: 100%" class="elTab">
          <el-table-column prop="number" label="费用类型" align="center">
            <template v-slot="scope">
              {{['入库费','仓储费','转货费','出库费'][scope.row.feeType - 1]}}
            </template>
          </el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" align="center"></el-table-column>
          <el-table-column prop="steelMillName" label="产地" align="center"></el-table-column>
          <el-table-column prop="specification" label="规格" align="center"></el-table-column>
          <el-table-column prop="model" label="材质" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量(吨)" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价(元/吨)" align="center">
            <template v-slot="scope">{{scope.row.unitPrice==0?0:scope.row.unitPrice?scope.row.unitPrice:'-'}}</template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeAmount" label="金额(元)" align="center">
            <template v-slot="scope">{{scope.row.feeAmount==0?0:scope.row.feeAmount?scope.row.feeAmount:'--'}}</template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" style="margin: 15px auto">
        <el-button @click="closeadd">取 消</el-button>
        <el-button v-if="isJiesuan" type="primary" @click="jiesuanRk">结算入库</el-button>
        <el-button type="primary" :loading="Loading" @click="addDialog">确认入库</el-button>
      </div>
    </el-dialog>
    <el-dialog @close="closeDialogFile" title="提示" :visible.sync="confirmMark" :close-on-click-modal="false" width="30%" center>
      <div style="margin: 15px auto" class="el-dialog--center">
        是否确认入库
      </div>
      <div style="margin: 15px auto" class="el-dialog--center">
        <el-button @click="closeDialogFile">取消</el-button>
        <el-button type="primary" @click="confirmQueding()">确定</el-button>
      </div>
    </el-dialog>
    <jiesuan-dialog v-if="jiesuanVisible" :jiesuanVisible.sync="jiesuanVisible" :title="jiesuanTitle" :customer="jiesuankehu" :customerTaxid="customer" :totalFee="totalFee" :params="params" :table="table" @colseDialog="colseDialog"></jiesuan-dialog>
  </div>
</template>

<script>
import {
  zidianKuwei,
  JfunloadConfirm,
  JfconfirmThreadExp,
  JfgetThreadDetailExpList,
  getfeeJc
} from '@/api/wms-access'
import {
  getQueryCusterData // 客户
} from '@/api/platform-settlement'
import { getWeighingMethodList, checkZkdJcFeeNameYesOrNo } from '@/api/wms-stock'
import { dateFormat1 } from '@/utils/util.js'
import jiesuanDialog from '../../jiesuanDialog.vue'
export default {
  components: { jiesuanDialog },
  name: 'xieCheDialog',
  data () {
    return {
      table: [],
      warehouseOptions: [],
      Loading: false,
      confirmMark: false,
      jiesuanVisible: false,
      jiesuanTitle: '结算入库',
      keHuOptions: [], // 所属客户下拉框
      customer: '',
      isJiesuan: false,
      feeTable: [],
      totalFee: 0,
      changeList: [],
      jiesuankehu: '',
      params: {}
    }
  },
  props: {
    xcVisible: {
      type: Boolean,
      default: false
    },
    chepai: {
      type: String,
      default: ''
    },
    instockId: {
      type: String
    },
    warehouseId: {
      type: String
    },
    customerName: {
      type: String
    },
    customerTaxId: {
      type: String
    }
  },
  watch: {
    customerName: {
      immediate: true,
      handler (val) {
        if (val) {
          this.jiesuankehu = val
        }
      }
    },
    customerTaxId: {
      immediate: true,
      handler (val) {
        if (val) {
          console.log(val)
          this.customer = val
        }
      }
    }
  },
  methods: {
    colseDialog (val) {
      this.jiesuanVisible = val
      this.$emit('update:xcVisible', false)
      this.$parent.chaxun()
    },
    customerChange (val) {
      this.customer = val
      this.jiesuankehu = this.keHuOptions.filter(item => item.itemNo == val)[0].showName
      this.getfeeJcS()
    },
    jiesuanRk () {
      let guobangTime = dateFormat1(new Date().getTime(), 'YYYY-MM-ss h-m-s')
      for (let i = 0; i < this.table.length; i++) {
        this.table[i].weighingDate = guobangTime
        console.log(this.table[i])
        if (this.table[i].number == '') {
          this.$message({ message: '请填写件数', type: 'error' })
          return
        } else if (this.table[i].inWeighingMethod == '2' && this.table[i].weighingWeight == '') {
          this.$message({ message: '请填写过磅净重', type: 'error' })
          return
        } else if (this.table[i].warehouseId == null || this.table[i].warehouseId == '') {
          this.$message({ message: '请选择仓位', type: 'error' })
          return
        } else if (this.table[i].number == 0) {
          this.$message({ message: '件数不能为零', type: 'error' })
          return
        }
      }
      if (this.feeTable.length > 0) {
        for (let i = 0; i < this.feeTable.length; i++) {
          let item = this.feeTable[i]
          if (item.unitPrice == null) {
            this.$message({ message: '没有找到单价信息，无法入库', type: 'error' })
            return
          }
        }
      }

      this.params = {
        instockId: this.instockId,
        inType: '1',
        payCustomerName: this.jiesuankehu,
        payCustomerNameTaxId: this.customer,
        feeList: this.feeTable
      }
      this.jiesuanVisible = true
    },

    closeDialogFile () {
      this.confirmMark = false
      this.Loading = false
    },
    getfeeJcS () {
      getfeeJc({
        instockId: this.instockId,
        customerTaxId: this.customer,
        changeList: this.changeList
      })
        .then(res => {
          console.log(res)

          this.isJiesuan = true
          this.feeTable = res.feeList
          this.totalFee = res.totalFee
        })
        .catch(err => {
          if (err.code == 1) {
            this.isJiesuan = false
            this.feeTable = null
          } else {
            this.isJiesuan = false
            this.feeTable = null

            // this.$message({ message: err.message, type: 'error' })
          }
        })
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
    },
    // 是否显示下拉框
    isShowSelectOptions (isShowSelectOptions) {
      if (!isShowSelectOptions) this.$refs.selectProvinces.blur()
    },
    closeadd () {
      this.$emit('update:xcVisible', false)
    },
    addDialog () {
      let guobangTime = dateFormat1(new Date().getTime(), 'YYYY-MM-ss h-m-s')
      for (let i = 0; i < this.table.length; i++) {
        this.table[i].weighingDate = guobangTime
        if (this.table[i].number == '') {
          this.$message({ message: '请填写件数', type: 'error' })
          return
        } else if (this.table[i].inWeighingMethod == '2' && this.table[i].weighingWeight == '') {
          this.$message({ message: '请填写过磅净重', type: 'error' })
          return
        } else if (this.table[i].warehouseId == '' || this.table[i].warehouseId == null) {
          this.$message({ message: '请选择仓位', type: 'error' })
          return
        } else if (this.table[i].number == 0) {
          this.$message({ message: '件数不能为零', type: 'error' })
          return
        }
      }
      if (this.feeTable != null) {
        for (let i = 0; i < this.feeTable.length; i++) {
          let item = this.feeTable[i]
          if (item.unitPrice == null) {
            this.$message({ message: '没有找到单价信息，无法入库', type: 'error' })
            return
          }
        }
      }
      this.Loading = true
      JfunloadConfirm(this.table)
        .then(res => {
          this.confirmMark = true
        })
        .catch(err => {
          this.Loading = false
          this.$message({ message: err.message, type: 'error' })
        })
    },
    confirmQueding () {
      JfconfirmThreadExp({
        instockId: this.instockId,
        inType: '2',
        payCustomerName: this.jiesuankehu,
        payCustomerNameTaxId: this.customer,
        feeList: this.feeTable
      })
        .then(res => {
          this.confirmMark = false
          this.$message({ message: '操作成功!', type: 'success' })
          this.$emit('update:xcVisible', false)
          this.Loading = false
          this.$parent.chaxun()
        })
        .catch(error => {
          this.Loading = false
          this.$message({ message: error.message, type: 'error' })
        })
    },
    NumberInput (row) {
      row.weight = parseFloat((row.number / 1 * row.singletonWeight).toFixed(6))
      if (row.number != '') {
        this.changeList.forEach(item => {
          if (item.instockSummaryId == row.instockSummaryId) {
            item.number = row.number
            if (row.inWeighingMethod == '1') {
              item.allWeight = row.weight
            }
          }
        })
        this.getfeeJcS()
      }
    },
    weighingWeightChange (row) {
      if (row.inWeighingMethod == '2') {
        this.changeList.forEach(item => {
          if (item.instockSummaryId == row.instockSummaryId) {
            item.allWeight = row.weighingWeight
          }
        })
        this.getfeeJcS()
      }
    },
    selectCangwei (row) {
      if (row.warehouseId != '') {
        let warehouse = this.warehouseOptions.filter(item => item.warehouseId == row.warehouseId)[0]
        row.warehouseName = warehouse.warehouseName
        this.changeList.forEach(item => {
          if (item.instockSummaryId == row.instockSummaryId) {
            item.doorFlag = warehouse.doorFlag
          }
        })
        if (this.isJiesuan) {
          this.getfeeJcS()
        }
      }
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({
      })
        .then((res) => {
          this.warehouseOptions = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 货物详情
    JfgetThreadDetailExpLists () {
      JfgetThreadDetailExpList(
        {
          instockId: this.instockId
        }
      )
        .then(res => {
          this.table = res

          this.table.forEach(item => {
            item.weight = parseFloat((item.number / 1 * item.singletonWeight / 1).toFixed(6))
            // item.weighingWeight = ''
            let obj = {
              instockSummaryId: item.instockSummaryId,
              allWeight: item.allWeight,
              number: item.number,
              // 修改逻辑：需要把过磅净重数据带过来
              weighingWeight: item.weighingWeight
            }
            this.changeList.push(obj)
            // item.warehouseId = ''
            // item.warehouseName = ''
            getWeighingMethodList(
              {
                productType: item.productType
              }
            )
              .then(res => {
                if (res.length > 0) {
                  item.inWeighingMethod = res[0].inWeighingMethod
                } else {
                  this.$message({ message: '计重方式未配置，请联系管理员', type: 'error' })
                }
              })
              .catch(err => {
                this.$message({ message: err.message, type: 'error' })
              })
          })
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    checkZkdJcFeeNameYesOrNos (param) {
      checkZkdJcFeeNameYesOrNo({ feeName: param })
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    }
  },
  mounted () {
    this.JfgetThreadDetailExpLists()
    this.getQueryCusterData()
    this.getfeeJcS()
  },
  created () {
    this.zidianKuweiS()
    this.checkZkdJcFeeNameYesOrNos('入库费')
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        if (_this.confirmMark == true) {
          _this.confirmQueding()
        } else {
          _this.addDialog()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.jiesuanCustomer::before {
  content: '*';
  color: red;
}
.detailsTitle {
  position: relative;
  .positionA {
    position: absolute;
    top: 0px;
    left: 110px;
    span {
      color: red;
    }
  }
}
</style>
